import { render, staticRenderFns } from "./message-settings.vue?vue&type=template&id=60e4a779"
import script from "./message-settings.vue?vue&type=script&lang=js"
export * from "./message-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e4a779')) {
      api.createRecord('60e4a779', component.options)
    } else {
      api.reload('60e4a779', component.options)
    }
    module.hot.accept("./message-settings.vue?vue&type=template&id=60e4a779", function () {
      api.rerender('60e4a779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/message-settings.vue"
export default component.exports